import { combineReducers } from 'redux';
import { menuPageReducer } from '../menuPageReducer';
import { checkoutPageReducer } from '../checkoutPageReducer';
import { dialogReducer } from '../dialogReducer';
import { appReducer } from '../appReducer';
import { submitReducer } from '../submitReducer';

export const rootReducer = combineReducers({
  app: appReducer,
  checkoutPage: checkoutPageReducer,
  dialog: dialogReducer,
  menuPage: menuPageReducer,
  submit: submitReducer,
});
